import { useTranslation } from 'react-i18next';

import { Dropdown, DropdownItem, InlineAlert } from '@amzn/storm-ui';
import { FormRow } from '@amzn/storm-ui-column-form-kit';

import { VALID_ORG_NAMES } from '../../Shared/constants/orgConstants';

const OrgNameDropDown = ({
  orgName,
  setOrgName,
  fieldError = '',
}: {
  orgName: string | null;
  setOrgName: (value: string) => void;
  fieldError?: string;
}) => {
  const { t } = useTranslation();

  return (
    <FormRow
      id="orgName"
      label={t('org-name-label')}
      controlComponents={[
        (componentId) => (
          <>
            <Dropdown
              id={componentId}
              selectedValue={orgName || ''}
              onChange={(value) => setOrgName(value)}
              error={!!fieldError}
            >
              {!orgName && (
                <DropdownItem
                  id="dropdown-item-org-name-placeholder"
                  value=""
                  disabled
                >
                  {t('select-org-name-placeholder')}
                </DropdownItem>
              )}
              {VALID_ORG_NAMES.map((org) => (
                <DropdownItem
                  key={org}
                  id={`dropdown-item-org-${org}`}
                  value={org}
                >
                  {org}
                </DropdownItem>
              ))}
            </Dropdown>
            {!!fieldError && (
              <InlineAlert message={fieldError} variant="error" />
            )}
          </>
        ),
      ]}
    />
  );
};

export default OrgNameDropDown;
